module.exports = __webpack_public_path__ + "static/24-slideshow-c3da5d5fdce502874c3cc44dbac879d5.jpg";